import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import LoginAPIvalidation from "./LoginAPIvalidation";
import "./Login.css";
import CryptoJS from "crypto-js";
// import { OtpInput } from "reactjs-otp-input";
import OTPComponent from "./OTPComponent";
import NotifyMessageNoReload from "../Others/NotifyMessageNoReload";
import NotifyMessage from "../Others/NotifyMessage";
import { Helmet } from "react-helmet";
import { useAuth } from "../../Store/AuthContext";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";
const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

export default function Login() {
  const { RendomTokenfetch } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // const Auth = localStorage.getItem("userid");
  // if (Auth === null) {
  //   navigate("/");
  // }
  // if (localStorage.getItem("userid") !== "") {
  //   navigate("/");
  // }

  const [error, setError] = useState({});
  const [number, setNumber] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOTP] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isVisiblePassword, setisVisiblePassword] = useState(false);
  const [isNumberRead, setisNumberRead] = useState(false);
  const [isVisible, setisVisible] = useState(false);
  const [ClickGanrate, setClickGanrate] = useState(false);
  const [timer, setTimer] = useState(59); // 59 second timer
  const [isTimerRunning, setIsTimerRunning] = useState(false);

  const handleKeyPress = (e) => {
    const charCode = e.which || e.keyCode;
    if (charCode < 48 || charCode > 57) {
      e.preventDefault();
    }
  };

  // console.log(number);
  const handleEnterOTP = (otp) => setOTP(otp);

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handaleOTP = () => {
    setisVisiblePassword(isVisiblePassword === false ? true : false);
    setNumber("");
  };

  // if (number === "") {
  //   setisNumberRead(false);
  // }

  useEffect(() => {
    let interval = null;
    if (isTimerRunning && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(interval);
      setClickGanrate(false); // Hide OTP input
      setIsTimerRunning(false);
      setTimer(59); // reset timer for next time
    }

    return () => clearInterval(interval);
  }, [isTimerRunning, timer]);

  const handaleGanrate = (event) => {
    event.preventDefault();

    if (number !== "" && isVisiblePassword === true) {
      setisVisible(isVisible === false ? true : false);
    }

    let fdata = new FormData();
    fdata.append("number", number);

    // console.log(Data);

    axios
      .post(`${WebsiteAPIurl}loginOtp`, fdata, {
        headers: {
          Authorization: RendomTokenfetch,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        // console.log(response.data);
        if (number) {
          if (response.data.Status === "1") {
            setClickGanrate(true);
            // setisChangeNumber(true);
            setisNumberRead(true);
            setOTP("");
            setTimer(59); // Reset and start timer
            setIsTimerRunning(true);
            NotifyMessageNoReload(response.data.msg, "success", true);
          } else {
            NotifyMessageNoReload(response.data.msg, "danger", true);
          }
        } else {
          setError(LoginAPIvalidation(response.data.form_validation));
        }
      });
    // .catch((error) => {
    //   alert(error);
    // });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let fdata = new FormData();
    fdata.append("number", number);
    if (isVisiblePassword === false) {
      fdata.append("loginType", "1");
      fdata.append("password", password);
    } else {
      fdata.append("loginType", "2");
      fdata.append("otp", otp);
    }

    // console.log(Data);
    try {
      axios
        .post(`${WebsiteAPIurl}userlogin`, fdata, {
          headers: {
            Authorization: RendomTokenfetch,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          // console.log(response.data);
          if ((number && password) || (number && otp)) {
            if (response.data.Status === "1") {
              const userId = response.data.userdata.userid;

              const encryptedUserId = CryptoJS.AES.encrypt(
                userId.toString(),
                SECRET_KEY
              ).toString();
              localStorage.setItem("userid", encryptedUserId);

              const returnPath = location.state?.from || "/deshboard";
              navigate(returnPath); // Redirect to previous page
              window.dispatchEvent(new Event("storage"));
              NotifyMessage(response.data.msg, "success", true);
            } else {
              NotifyMessageNoReload(response.data.msg, "danger", true);
              // setError(LoginAPIvalidation(response.data.form_validation));
            }
          } else {
            setError(LoginAPIvalidation(response.data.form_validation));
          }
        });
    } catch (error) {
      alert(error);
    }
  };

  return (
    <>
      <Helmet>
        <title>{"Login"}</title>{" "}
        <meta name="robots" content="index, follow"></meta>
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <section className="login-section section_padding_top bgc-home20">
        <div className="login-form default-form login_page_form">
          <div className="form-inner">
            <h3>Login Here</h3>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>
                  Mobile Number<span className="text-danger">*</span>
                  {/* {isChangeNumber && (
                    <Link className="mx-3 text-danger">Change Number</Link>
                  )} */}
                </label>
                <div className="otpganratebox">
                  <input
                    className="form-controll"
                    type="text"
                    name="number"
                    value={number}
                    onChange={(e) => setNumber(e.target.value)}
                    onKeyPress={handleKeyPress}
                    maxLength={10}
                    inputMode="numeric"
                  />
                  {isVisiblePassword && (
                    // <p
                    //   className="ganrarteotpbtn"
                    //   id="ganrarteotpbtn"
                    //   onClick={handaleGanrate}
                    // >
                    //   {isNumberRead === true ? "Resend OTP" : "Send OTP"}
                    // </p>
                    <p
                      className={`ganrarteotpbtn ${
                        isTimerRunning ? "disabled" : ""
                      }`}
                      id="ganrarteotpbtn"
                      onClick={!isTimerRunning ? handaleGanrate : null}
                      style={{
                        cursor: isTimerRunning ? "not-allowed" : "pointer",
                      }}
                    >
                      {isNumberRead && !isTimerRunning
                        ? "Resend OTP"
                        : "Send OTP"}
                    </p>
                  )}
                </div>
                {error.number && number === "" && (
                  <span className="text-danger">* {error.number}</span>
                )}
              </div>

              {isVisiblePassword === false ? (
                <>
                  <div className="form-group">
                    <label>
                      Password<span className="text-danger">*</span>
                    </label>
                    <input
                      id="password-field"
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span
                      onClick={togglePasswordVisibility}
                      className="paaswordshowhide"
                    >
                      {showPassword ? (
                        <i className="fa fa-eye" aria-hidden="true"></i>
                      ) : (
                        <i className="fa fa-eye-slash" aria-hidden="true"></i>
                      )}
                    </span>

                    {error.password && password === "" && (
                      <span className="text-danger">* {error.password}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <div className="text text-end">
                      <Link to="/forgot-password">Forgot password?</Link>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}

              {ClickGanrate === true &&
              isVisiblePassword === true &&
              isTimerRunning ? (
                <>
                  <div className="form-group">
                    <label>
                      Enter OTP<span className="text-danger">*</span>
                      <span
                        className="mx-3 text-muted"
                        style={{ fontSize: "14px" }}
                      >
                        (Valid for {timer}s)
                      </span>
                    </label>
                    <OTPComponent handleEnterOTP={handleEnterOTP} />
                    {error.otp && otp === "" && (
                      <span className="text-danger">* {error.otp}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <button
                      className="theme-btn btn-style-one"
                      type="submit"
                      name="submit"
                    >
                      Log In
                    </button>
                  </div>
                </>
              ) : (
                ""
              )}
              {isVisiblePassword === false && (
                <div className="form-group">
                  <button
                    className="theme-btn btn-style-one"
                    type="submit"
                    name="submit"
                  >
                    Log In
                  </button>
                </div>
              )}
            </form>

            {/* <div className="bottom-box text-center d-block">
              <div className="text">
                Don't have an account ? <NavLink to="/register">Signup</NavLink>
              </div>
            </div> */}
            <div
              className={`bottom-box ${
                isVisiblePassword === true ? "mt-2" : ""
              }`}
            >
              <div className="text">
                <p onClick={handaleOTP} className="otpbtn">
                  {isVisiblePassword === false
                    ? "Login With OTP"
                    : "Login With Password"}
                </p>
              </div>
              <div className="text">
                Don't have an account ? <NavLink to="/register">Signup</NavLink>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
